import { type HTMLAttributes } from 'react';
import Link from 'next/link';
import clsx from 'clsx';

import { getCollabUrl } from '@/domains/collaborators/collaborators.utils';
import { isAgencyCollabAgent } from '@/domains/collaborators/collaborators.store';
import { RichText } from '@/stories/atoms/RichText/RichText';
import { Icon } from '@/stories/atoms/Icon/Icon';
import { PhoneButton } from '@/stories/atoms/PhoneButton/PhoneButton';
import { Avatar } from '@/stories/atoms/Avatar/Avatar';
import { CollabContactModal } from './CollabContactModal';

import styles from './collab-card.module.css';
import { Button } from '@/stories/atoms/Button/Button';

type FullProps = {
  variant: 'full',
  agence: string,
}

type InlineProps = {
  variant?: 'inline'
  agence?: string
}

export type CollabCardProps = {
  nom: string,
  prenom: string,
  fonction: string,
  id?: string | null,
  titre?: string,
  photo?: string,
  phone?: string,
  biographie?: string,
} & (FullProps | InlineProps) & Omit<HTMLAttributes<HTMLElement>, 'id'>

export const CollabCard = ({ variant, phone, nom, prenom, id, fonction, photo, biographie, agence, ...props }: CollabCardProps)=> {
  const isAgent = id ? isAgencyCollabAgent(id) : false

  return (
    <div className={clsx(styles.card, props.className, variant && styles[variant])}>
      <div className={clsx(styles.wrapper)}>
        <div className={styles.collab}>
          {isAgent ? (
            <Link href={getCollabUrl({nom, prenom})} className={styles.avatar}>
              <Avatar photo={photo} prenom={prenom} nom={nom} size={variant === 'inline' ? 60 : 110}/>
            </Link>
          ) : <Avatar className={styles.avatar} photo={photo} prenom={prenom} nom={nom} size={variant === 'inline' ? 60 : 110}/>}
          <div>
            <div className={styles.nom}>{prenom} {nom}</div>
            { fonction && <div className={styles.fonction}>{fonction}</div>}
          </div>
        </div>
        {isAgent && variant !== 'full' && (
          <Button
            className={clsx(variant === 'inline' && styles.link)}
            rounded={variant === 'inline'}
            asChild
            >
            <Link href={getCollabUrl({nom, prenom})}>
            <span className={clsx(variant === 'inline' ? 'sr-only' : '')}>Voir le profil de l&apos;agent</span>
            <Icon icon='arrow-up-right'/>
            </Link>
          </Button>
        )}
        {isAgent && id && (
          <div className={styles.btns}>
            {phone && <PhoneButton className={styles.phone} number={phone}/>}
            {variant === 'full' && (
              <CollabContactModal agence={agence} collabId={id}/>
            )}
          </div>
        )}
      </div>
      {biographie && variant === 'full' && (
        <div className={clsx(styles.bio, 'text-light')}>
          <RichText>{biographie}</RichText>
        </div>
      )}
    </div>
  )
};
